import type { FaireProductEntity } from "../../entity_types/product";

export const p_b9hvua5s25: FaireProductEntity = {
  token: "p_b9hvua5s25",
  type: "product",
  name: "440 lb Digital Shipping Scale",
  brandToken: "b_ajaj2rm3ar",
  brandName: "Store Supply Warehouse",
  imageUrl: "https://cdn.faire.com/fastly/0d5079eaa1652ef4e5128089e86e3f9134bd8ed412e3f585c394bf8e63a5fb55.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d638f9ec7efa4c23b8930b2d8fff6fbc13519bd6d48878e4c8bfbd867dcf4d93.jpeg",
    "https://cdn.faire.com/fastly/4f672b70284bd56b0be2e8c770286260892dc14afd3caa515a3a00a2104fbbf4.jpeg"
  ],
  priceDollars: 40,
  description: "Weigh everything from small parcels to large cartons with this 440 lb digital shipping scale. Four high-precision sensors give dependable readings.\n\n- Capacity: 0.1 to 440 lb\n- Accuracy: 0.02 lb from 0.1 to 44 lb; 0.2 lb from 45 to 440 lb\n- Platform: about 10.8\" x 10.8\" x 1.2\", carbon fiber\n- Separate backlit LCD on a coil cord stays readable under large boxes\n- Tare and hold functions\n- Units: kg, oz and lb\n- Battery or Type-C power; auto shutoff after about 2 minutes\n- Includes mounting slots and hardware for the display\n\nFor best accuracy, use on a hard, level surface.",
  tags: [],
  msrpDollars: 60,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:05:16.928Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
